import React, { useState, useEffect } from 'react';
import homeImg from '../hampton-bay-configurator-home.jpg';

const Step1Selector = ({ onNext, defaultValues }) => {
  const [wallWidth, setWallWidth] = useState(defaultValues.wallWidth || '');
  const [sinkCount, setSinkCount] = useState(defaultValues.sinkCount || 1);
  const [vanityPlacement, setVanityPlacement] = useState(defaultValues.vanityPlacement || 'centered');
  const [error, setError] = useState(null);

  /* ── auto-reset sinkCount when wallWidth < 48 ───────────────────── */
  const disableTwo = Number(wallWidth) < 48;
  useEffect(() => {
    if (disableTwo && sinkCount === 2) setSinkCount(1);
  }, [disableTwo, sinkCount]);
  /* ── auto-reset sinkCount when wallWidth < 48 ───────────────────── */
  const disableOne = Number(wallWidth) > 72;
  useEffect(() => {
    if (disableOne && sinkCount === 1) setSinkCount(2);
  }, [disableOne, sinkCount]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (wallWidth < 24 || wallWidth > 120) {
      setError("Please enter a wall width between 24” and 120”.");
      return;
    }
    if (!vanityPlacement) {
      setError("Please select a vanity placement.");
      return;
    }
    setError(null);
    onNext({ wallWidth, sinkCount, vanityPlacement });
  };

  return (
    <div>

              <div class="row home-row">
            <div class="home-form">

 <h2 className="card-title mb-3">Vanity Setup</h2>
            <p className="text-muted mb-4">Enter the width, number of sinks, and placement in the room to see available configurations.</p>

            {error && <div className="alert alert-danger">{error}</div>}

            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <h5 htmlFor="wallWidth" className="form-label fw-semibold">
                  Width of Vanity <span className="text-muted">(in inches)</span>
                </h5>
                <input
                  type="number"
                  className="wall-input"
                  id="wallWidth"
                  min={24}
                  max={120}
                  value={wallWidth}
                  onChange={(e) => setWallWidth(Number(e.target.value))}
                  placeholder="24–120&rdquo;"
                />
              </div>

              <div className="mb-4">
                <h5 className="form-label fw-semibold">Number of Sink Bases</h5>
             <div id="sink-options" class="sink-selection">
                  <div className="sink-option">
         
                    <input
                      className=""
                      type="radio"
                      name="sinkCount"
                      id="sink1"
                      disabled={disableOne}
                      value="1"
                      checked={sinkCount === 1}
                      onChange={() => setSinkCount(1)}
                    />
                    <label className="fo" htmlFor="sink1">
                                 <svg width="100" height="52" viewBox="0 0 100 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M43.9468 30.466V9.21065C43.9468 7.6 44.5761 6.05532 45.6963 4.91642C46.8166 3.77752 48.3359 3.1377 49.9202 3.1377C51.5044 3.1377 53.0238 3.77752 54.144 4.91642C55.2642 6.05532 55.8936 7.6 55.8936 9.21065V10.7289" stroke="black" stroke-width="3.29032" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M58.8803 22.8748C58.8803 23.6801 58.5657 24.4525 58.0055 25.0219C57.4454 25.5914 56.6857 25.9113 55.8936 25.9113C55.1015 25.9113 54.3418 25.5914 53.7817 25.0219C53.2216 24.4525 52.9069 23.6801 52.9069 22.8748C52.9069 21.1987 55.8936 18.3201 55.8936 18.3201C55.8936 18.3201 58.8803 21.1987 58.8803 22.8748Z" stroke="black" stroke-width="3.29032" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M67.8404 30.4661C67.8404 35.298 65.9524 39.9321 62.5917 43.3488C59.231 46.7655 54.6729 48.6849 49.9202 48.6849C45.1675 48.6849 40.6094 46.7655 37.2487 43.3488C33.888 39.9321 32 35.298 32 30.4661H67.8404Z" stroke="black" stroke-width="3.29032" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                        <span>1 Sink</span>
                    </label>
                  </div>
                  <div className="sink-option">
                    <input
                      className=""
                      type="radio"
                      name="sinkCount"
                      id="sink2"
                      disabled={disableTwo}
                      value="2"
                      checked={sinkCount === 2}
                      onChange={() => setSinkCount(2)}
                    />
                    <label className="" htmlFor="sink2"><svg width="100" height="52" viewBox="0 0 100 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.9468 30.3283V9.07296C18.9468 7.46231 19.5761 5.91763 20.6963 4.77873C21.8166 3.63983 23.3359 3 24.9202 3C26.5044 3 28.0238 3.63983 29.144 4.77873C30.2642 5.91763 30.8936 7.46231 30.8936 9.07296V10.5912" stroke="black" stroke-width="3.29032" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M33.8803 22.7371C33.8803 23.5424 33.5657 24.3148 33.0055 24.8842C32.4454 25.4537 31.6857 25.7736 30.8936 25.7736C30.1015 25.7736 29.3418 25.4537 28.7817 24.8842C28.2216 24.3148 27.9069 23.5424 27.9069 22.7371C27.9069 21.061 30.8936 18.1824 30.8936 18.1824C30.8936 18.1824 33.8803 21.061 33.8803 22.7371Z" stroke="black" stroke-width="3.29032" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M42.8404 30.3284C42.8404 35.1603 40.9524 39.7944 37.5917 43.2111C34.231 46.6278 29.6729 48.5472 24.9202 48.5472C20.1675 48.5472 15.6094 46.6278 12.2487 43.2111C8.88802 39.7944 7 35.1603 7 30.3284H42.8404Z" stroke="black" stroke-width="3.29032" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M69.9468 30.3283V9.07296C69.9468 7.46231 70.5761 5.91763 71.6963 4.77873C72.8166 3.63983 74.3359 3 75.9202 3C77.5044 3 79.0238 3.63983 80.144 4.77873C81.2642 5.91763 81.8936 7.46231 81.8936 9.07296V10.5912" stroke="black" stroke-width="3.29032" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M84.8803 22.7371C84.8803 23.5424 84.5657 24.3148 84.0055 24.8842C83.4454 25.4537 82.6857 25.7736 81.8936 25.7736C81.1015 25.7736 80.3418 25.4537 79.7817 24.8842C79.2216 24.3148 78.9069 23.5424 78.9069 22.7371C78.9069 21.061 81.8936 18.1824 81.8936 18.1824C81.8936 18.1824 84.8803 21.061 84.8803 22.7371Z" stroke="black" stroke-width="3.29032" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M93.8404 30.3284C93.8404 35.1603 91.9524 39.7944 88.5917 43.2111C85.231 46.6278 80.6729 48.5472 75.9202 48.5472C71.1675 48.5472 66.6094 46.6278 63.2487 43.2111C59.888 39.7944 58 35.1603 58 30.3284H93.8404Z" stroke="black" stroke-width="3.29032" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                        <span>2 Sinks</span></label>
                  </div>
                </div>
              </div>

              <div className="mb-4">
                <h5 className="form-label fw-semibold">Vanity Placement in Room</h5>
                <div className="placements">
                  {["one-wall", "two-walls", "centered"].map((placement) => (
                    <div key={placement}
                    className={placement}>
                      <input
                        className="btn-check"
                        type="radio"
                        name="vanityPlacement"
                        id={placement}
                        value={placement}
                        checked={vanityPlacement === placement}
                        onChange={() => setVanityPlacement(placement)}
                      />
                      <label className="button outline" htmlFor={placement}>
                        {placement === "one-wall" && "One Wall"}
                        {placement === "two-walls" && "Two Walls"}
                        {placement === "centered" && "Floating"}
                      </label>
                    </div>
                  ))}
                </div>
              </div>

              <div className="d-grid justify-center text-center">
                <button type="submit" className="button next">
                  Next Step →
                </button>
              </div>
            </form>

            </div>
            <div className="home-image">
              <img src={homeImg} alt="Hampton Bay Configurator Home" />
            </div>
        </div>

    </div>
  );
};

export default Step1Selector;
